import {Injectable} from "@angular/core";
import {Observable, throwError} from "rxjs";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppHttpInterceptor implements HttpInterceptor {

  private readonly UNAUTHORIZED_STATUS_CODE: number = 401;
  private readonly FORBIDDEN_STATUS_CODE: number = 403;
  private readonly NOT_FOUND_STATUS_CODE: number = 404;
  private readonly REDIRECTION_STATUS_CODE: number = 302;
  private readonly ZERO_STATUS_CODE: number = 0;

  constructor(private oauthService: OAuthService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(map(resp => {
        if (resp instanceof HttpResponse) {
          return resp;
        }

      }),
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          this.filterTimeouts(err);
        }
        return throwError(err);
      }));
  }

  private filterTimeouts(errorResponse: HttpErrorResponse): void {

    if (errorResponse.status === this.UNAUTHORIZED_STATUS_CODE
      || errorResponse.status === this.REDIRECTION_STATUS_CODE
      || errorResponse.status === this.ZERO_STATUS_CODE) {
      this.oauthService.initLoginFlow();
    }

    if (errorResponse.status === this.FORBIDDEN_STATUS_CODE) {
      this.router.navigate(['/not-authorized']);
    }

    if (errorResponse.status === this.NOT_FOUND_STATUS_CODE) {
      this.router.navigate(['/not-found']);
    }
  }
}
